import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Heading } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Thankyou() {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(Heading, {
    as: "h1",
    marginY: "small",
    children: __('Thank you !')
  });
}